import React, { useReducer } from "react";
import { motion, AnimatePresence } from "framer-motion";
import faqData from "../../data/faqData";

const reducer = (state, action) => {
  switch (action.type) {
    case "TOGGLE":
      return {
        ...state,
        activeColumn: action.column,
        openIndex:
          state.openIndex === action.index &&
          state.activeColumn === action.column
            ? null
            : action.index,
      };
    default:
      return state;
  }
};

const Section4 = () => {
  const [state, dispatch] = useReducer(reducer, {
    openIndex: null,
    activeColumn: null,
  });

  return (
    <section className="w-full py-10 px-4 sm:px-6 lg:px-12">
      <h2 className="text-3xl 2xl:text-5xl font-bold text-center mb-10">
        Frequently Asked Questions
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {[0, 1].map((column) => (
          <div key={column} className="flex flex-col gap-4">
            {faqData
              .slice(
                column === 0 ? 0 : Math.ceil(faqData.length / 2),
                column === 0 ? Math.ceil(faqData.length / 2) : faqData.length
              )
              .map((faq, index) => {
                const globalIndex =
                  column === 0 ? index : index + Math.ceil(faqData.length / 2);
                const isOpen =
                  state.openIndex === globalIndex &&
                  state.activeColumn === column;

                return (
                  <div
                    key={globalIndex}
                    className="bg-white shadow rounded-xl border border-gray-200 transition hover:shadow-lg">
                    <button
                      className="w-full text-left font-medium text-lg 2xl:text-2xl py-4 px-6 flex justify-between items-center focus:outline-none"
                      onClick={() =>
                        dispatch({ type: "TOGGLE", index: globalIndex, column })
                      }
                      aria-expanded={isOpen}>
                      {faq.question}
                      <span className="ml-4 text-gray-400 text-xl">
                        {isOpen ? "−" : "+"}
                      </span>
                    </button>
                    <AnimatePresence>
                      {isOpen && (
                        <motion.div
                          initial={{ opacity: 0, height: 0 }}
                          animate={{ opacity: 1, height: "auto" }}
                          exit={{ opacity: 0, height: 0 }}
                          transition={{ duration: 0.3 }}
                          className="px-6 pb-4 text-gray-700 text-base 2xl:text-xl"
                          dangerouslySetInnerHTML={{ __html: faq.answer }}
                        />
                      )}
                    </AnimatePresence>
                  </div>
                );
              })}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Section4;
